<template>
  <div class="list-items-action">
    <div class="w-[65%] lg:w-full lg:order-1 order-2">
      <CommonTutorSelectAction
        btn-class="w-full"
        :teacher="teacher"
        btn-size="sm-md"
        :btn-text="$t('actions.book_free_trial')"
        :need-disabled="false"
        @bookingClicked="$emit('bookingClicked')"
        @mouseLeave="$emit('mouseLeave')"
        @mouserOver="$emit('mouserOver')"
      />
    </div>
    <div class="w-[35%] lg:w-full lg:order-2 order-1">
      <BaseButton
        color="primary"
        :label="$t('common.actions.message')"
        class="w-full"
        size="sm-md"
        outline
        :loading="loading"
        @click="message"
      />
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import CommonTutorSelectAction from '~/components/common/tutor-select/tutor-select-action'
export default {
  name: 'TeacherListItemsAction',
  components: { CommonTutorSelectAction },
  inject: ['teacher'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions('liveChat', ['showLiveChat', 'storeLoading']),
    ...mapActions('authentication', ['saveActionAfterLogin']),
    async message () {
      if (!this.$auth.loggedIn) {
        this.saveActionAfterLogin({
          type: 'message',
          target: {
            visible: true,
            type: 'conversation',
            chatUserName: this.teacher.chatUsername
          }
        })
        this.$nuxt.$emit('AuthDialogLogin')
      } else {
        this.storeLoading(true)
        this.loading = true
        try {
          await this.showLiveChat({
            chatStatus: {
              visible: true,
              type: 'conversation',
              chatUserName: this.teacher.chatUsername
            },
            query: {
              role: 'STUDENT',
              chat_username: this.teacher.chatUsername
            }
          })
        } catch (e) {
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped>
.list-items-action {
  @apply flex flex-row lg:flex-col lg:space-y-2 space-y-0 space-x-2 lg:space-x-0
  justify-between lg:justify-center space-x-reverse;
}
</style>
